import { useAuth0 } from "@auth0/auth0-react";
import { CreditCard } from 'pages/NewFinance/NewCharge/PaymentMethods/CreditCard';
import React, { useEffect, useState } from 'react';

import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Loader from "components/loader/Loader";
import { useFormik } from "formik";

import { useDisableEnterKey } from "hook";
import FinanceService from 'Lib/API/Finance/index';
import { ACH } from 'pages/NewFinance/NewCharge/PaymentMethods/ACH';
import { toastr } from "react-redux-toastr";
import Button from "../button/Button";
import { UpdatePaymentMethodActions, UpdatePaymentMethodContainer, UpdatePaymentMethodContent, UpdatePaymentMethodFooter, UpdatePaymentMethodHeader, UpdatePaymentMethodSelected, UpdatePaymentMethodTitle } from './Theme';
const UpdatePaymentMethod = ({
  title = "Update Payment Information",
  closeModal,
  accountId,
  actionText = "Update",
  data,
  isInstallment,
  reFetchData
}) => {
  const { getAccessTokenSilently } = useAuth0();

  const [expanded, setExpanded] = useState(null);
  const [selected, setSelected] = useState(null);
  const [selectedAch, setSelectedAch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [getRecurringLoading, setGetRecurringLoading] = useState(false);
  const [updatePaymentMethodLoading, setUpdatePaymentMethodLoading] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [enableAddCard, setEnableAddCard] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const formik = useFormik({
    enableReinitialize: false,
    initialValues: {
    },
    validationSchema: "",
  });

  const getRecurringInfo = async () => {
    const lookupId = isInstallment ? data?.charge?.installmentDetails?.installmentId : (data?.transactionId || data?._id);
    // The backend only creates a recurring/installment payment record after the
    // first successful charge, so calling this before that point always 404s.
    // Skip the fetch instead of surfacing a "Recurring not found" error for a
    // charge that simply hasn't been billed yet.
    const hasExistingRecurringRecord = isInstallment
      ? !!data?.charge?.installmentDetails?.installmentId
      : !!data?.recurringDetails?.recurringPaymentId
        || parseFloat(data?.total_paid) > 0
        || parseFloat(data?.charge?.paid) > 0;
    if (!hasExistingRecurringRecord) {
      setPaymentDetails(null);
      return;
    }
    const token = await getAccessTokenSilently();
    setGetRecurringLoading(true);
    FinanceService.getRecurringInfo({
      token,
      id: lookupId,
      installment: isInstallment
    }).then((res) => {
      setPaymentDetails(res?.result?.paymentDetails);
    })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setGetRecurringLoading(false);
      });

  };

  const getMethods = async () => {
    const token = await getAccessTokenSilently();
    setIsLoading(true);
    FinanceService.getPaymentMethods(token).then((res) => {
      const paymentMethods = res?.result?.map((item) => {
        if (item?.type === "credit card") {
          return {
            id: "credit_card",
            title: "Credit Card",
            type: "credit_card",
            component: <CreditCard 
              accountId={accountId} 
              enableInstallments={false} 
              paymentGateway={item?.paymentGateway} 
              setEnableAddCard={setEnableAddCard}
              paymentMethodId={item?._id}
              source="updatePayments"
            />,
          };
        }
        else if (item?.type === "ach") {
          return {
            id: "ach",
            title: "ACH",
            type: "ach",
            component: <ACH
              accountId={accountId}
              source="updatePayments"
              setEnableAddCard={setEnableAddCard}
              paymentMethodId={item?._id}
            />,
          };
        }
      })?.filter((item) => item !== undefined);
      setPaymentMethods(paymentMethods);
    })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setIsLoading(false);
      });

  };
  useEffect(() => {
    if (!accountId) return;
    getMethods();
    getRecurringInfo();
  }, [accountId])

  useDisableEnterKey(true);


  const updatePaymentMethodHandler = async () => {
    const token = await getAccessTokenSilently();
    const payload = {
      id: isInstallment ? data?.charge?.installmentDetails?.installmentId : (data?.transactionId || data?._id),
      installment: isInstallment,
      providerId: selectedPaymentMethod?.id,
      paymentMethodId: selectedPaymentMethod?.paymentMethodId,
    };
    setUpdatePaymentMethodLoading(true);
    FinanceService.ReplacePaymentInfo({
      token,
      data: payload
    }).then((res) => {
      toastr.success("Success", "Payment method updated successfully");
      reFetchData();
      closeModal();
    })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setUpdatePaymentMethodLoading(false);
      });
  }

  return (
    <UpdatePaymentMethodContainer>
      <UpdatePaymentMethodHeader>
        <UpdatePaymentMethodTitle>{title}</UpdatePaymentMethodTitle>
      </UpdatePaymentMethodHeader>
      <UpdatePaymentMethodContent>
        {(isLoading || getRecurringLoading) ? <Loader />
          : paymentMethods.map((item, index) => (
            <div className="mb-1 cash-accordian" key={index}>
              <div className="finance-accordian-container">
                <Accordion
                  className={"finance-accordian"}
                  expanded={expanded === item.id}
                  onChange={(index, newExpanded) => {
                    setExpanded(newExpanded ? item.id : "");
                  }}
                >
                  <AccordionSummary
                    className={
                      expanded === item.id
                        ? "finance-accordian-header-expanded"
                        : "finance-accordian-header"
                    }
                    expandIcon={
                      <ExpandMoreIcon
                        style={!expanded ? { color: "#b5b5c3" } : { color: "#ffffff" }}
                      />
                    }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    {item.title}
                  </AccordionSummary>
                  <AccordionDetails className="finance-accordian-body">
                    <Typography >
                      {React.cloneElement(item.component, {
                        formik,
                        accountId,
                        onPaymentValueChange: () => { },
                        title: item.id,
                        selected,
                        setSelected,
                        selectedAch,
                        setSelectedAch,
                        selectedPaymentMethod,
                        setSelectedPaymentMethod,
                        activeProvider: paymentDetails?.providerId
                      })}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          ))}
      </UpdatePaymentMethodContent>
      <UpdatePaymentMethodFooter>
        <UpdatePaymentMethodSelected>
          {selectedPaymentMethod?.id && (
            <>
              <span>Selected payment method:</span>
              {selectedPaymentMethod?.nameOnAccount ? (

                <strong className="ml-2">{`${selectedPaymentMethod.nameOnAccount ? selectedPaymentMethod.nameOnAccount : ""} ${selectedPaymentMethod.accountNumber ? "/ " + selectedPaymentMethod.accountNumber : ""
                  }`}</strong>
              ) : (
                <strong className="ml-2">
                  {`${selectedPaymentMethod.country ? selectedPaymentMethod.country : ""} ${selectedPaymentMethod.brand ? selectedPaymentMethod.brand : ""
                    } (${selectedPaymentMethod.last4 ? selectedPaymentMethod.last4 : ""}), Exp: ${selectedPaymentMethod.exp_month}/${selectedPaymentMethod.exp_year
                    }`}
                </strong>
              )}
            </>
          )}
        </UpdatePaymentMethodSelected>
        <UpdatePaymentMethodActions>
          <Button
            onClick={() => updatePaymentMethodHandler()}
            variant="primary"
            size="md"
            style={{ minWidth: "100px" }}
            disabled={!selectedPaymentMethod?.id}
          >
            {updatePaymentMethodLoading ? (
              <span className="spinner spinner-white mr-5"></span>
            ) : (
              <span>{actionText}</span>
            )}
          </Button>
        </UpdatePaymentMethodActions>
      </UpdatePaymentMethodFooter>
    </UpdatePaymentMethodContainer>
  )
}

export default UpdatePaymentMethod